import { getRequest, postRequest, deleteRequest } from "app/axiosClient";
import {
  getWorkdoneRecords,
  getProjectTaskList,
  resetState,
} from "./WorkDoneSlice";
import {
  showLoader,
  hideLoader,
} from "../CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "common/utils/OpenNotificationWithIcon";
export const getWorkdoneRecordsApi = (path) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/WorkDone/WorkDoneDetails?appointmentNbr=${path}`).then(
      (res) => {
        dispatch(getWorkdoneRecords(res.data));
        dispatch(hideLoader());
      }
    );
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "workdone.Unabletofetchworkdone"
    );
    dispatch(hideLoader());
  }
};
export const getProjectTaskListAPi = (projectpath) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/getProjectTaskList?projectID=${projectpath}`).then(
      (res) => {
        dispatch(getProjectTaskList(res.data));
        dispatch(hideLoader());
      }
    );
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "workdone.UnablefetchProjecttasklist"
    );

    dispatch(hideLoader());
  }
};
export const UpdateWorkDoneRecordsApi = (values) => (dispatch) => {
  const input = `${values.appointmentNbr}&noteID=${values.id}`;
  try {
    dispatch(showLoader());
    postRequest(`api/WorkDone/UpdateWorkDone`, values).then((res) => {
      dispatch(getWorkdoneRecordsApi(input));
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "success",
        "Common.Success",
        "",
        "workdone.WorkdoneUpdatedSuccessfully"
      );
    });
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "workdone.Unableupdateworkdonedetails"
    );
    dispatch(hideLoader());
  }
};
export const clearWorkDoneState = () => (dispatch) =>
  Promise.all([dispatch(resetState())]);
